// extracted by mini-css-extract-plugin
export default {"stickyGroup":"JQlgCPKupQD9HO2rOL5s","ground":"z9yLGGTc6oPtbcfmJUcA"};